<template>
  <pt-integral-particulars-table :totalNumber="totalNumber" ref="table" :tableLabel="tableLabel" class="pt-integral-particulars-table__withData"
  @getTableData="getTableData" :tableData="tableData">
    <slot/>
  </pt-integral-particulars-table>
</template>

<script>
import PtIntegralParticularsTable from './index'
export default {
  name: 'pt-integral-particulars-table__withData',
  components: {
    'pt-integral-particulars-table': PtIntegralParticularsTable
  },
  props: {
    tableLabel: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        this.getTableData(this.page)
      },
      deep: true
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0
    }
  },
  computed: {
    page () {
      return this.$refs.table.page
    }
  },
  methods: {
    getTableData (page, next) {
      let data = {
        ...this.paramsData,
        pageableParam: {
          page: this.page,
          size: this.pageSize,
          sort: ['createdDate,desc']
        }
      }
      this.$emit('membersPointsSum', data)
      this.$store.dispatch('membersPointsDetails', data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$message.error(err || '获取积分明细失败')
      })
    }
  }
}
</script>
